import {
  makeStyles,
  shorthands,
  tokens,
  type GriffelStyle,
} from "@fluentui/react-components";
import type { Appearance } from "../data";

type Styles = {
  root: GriffelStyle;
  dropdown: GriffelStyle;
  truncatedText: GriffelStyle;
  placeholderText: GriffelStyle;
  optionContainer: GriffelStyle;
  optionBadge: GriffelStyle;
  filterListBoxOverflowFrom10Items: GriffelStyle;
};

const defaultStyles: Styles = {
  root: {
    display: "flex",
    alignItems: "center",
    alignSelf: "stretch",
    justifyContent: "flex-start",
    flexWrap: "wrap",
    ...shorthands.gap("1rem"),
    zIndex: 1, // Add z-index style so dropdown doesn't get hidden behind other elements
  },

  filterListBoxOverflowFrom10Items: {
    maxHeight: "380px !important",
  },

  optionContainer: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    flexDirection: "row",
    overflowWrap: "anywhere",
  },

  optionBadge: {
    marginRight: "6px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    width: "20px",
    flexShrink: 0,
  },

  dropdown: {
    minWidth: "max-content",
    maxWidth: "240px",
    flex: 1,
    width: "20vw",
    "@media (max-width: 480px)": {
      maxWidth: "100%",
    },
  },

  truncatedText: {
    overflowX: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },

  placeholderText: {
    color: tokens.colorNeutralForeground4,
  },
};

const singleColumnStyles: Styles = {
  ...defaultStyles,
  dropdown: {
    ...defaultStyles.dropdown,

    "@media (max-width: 480px)": {
      maxWidth: "148px",
    },

    "& button": {
      color: tokens.colorNeutralForeground1,
      fontSize: tokens.fontSizeBase300,
      fontStyle: "normal",
      fontWeight: tokens.fontWeightSemibold,
      lineHeight: "20px",
    },
  },
};

export const useInAppStyles = makeStyles(defaultStyles);
export const useCopilotLabStyles = makeStyles(defaultStyles);
export const useM365Styles = makeStyles(defaultStyles);
export const useSingleColumnStyle = makeStyles(singleColumnStyles);

export const useStyles = (appearance?: Appearance) => {
  switch (appearance) {
    case "in-app":
      return useInAppStyles;
    case "web":
    case "web-v3":
      return useCopilotLabStyles;
    case "m365":
    case "bing-web":
    case "win-copilot":
      return useM365Styles;
    case "bing-mobile":
    case "underside":
    case "single-col":
      return useSingleColumnStyle;
    default:
      return useInAppStyles;
  }
};
